import * as yup from 'yup';

const LoginSchema = yup.object({
  phoneNumber: yup.string().trim().required('msg_error_input_require'),
  password: yup.string().trim().required('msg_error_input_require'),
  captchaToken: yup.string().trim().required('Is your Robot'),
});

// Validation schema for email
const emailSchema = yup.object().shape({
  email: yup.string().email('Email không hợp lệ').required('Email là bắt buộc'),
});

// Validation schema for new password
const passwordSchema = yup.object().shape({
  password: yup
    .string()
    .min(7, 'Mật khẩu phải có nhiều hơn 6 ký tự')
    .required('Mật khẩu là bắt buộc'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('password')], 'Mật khẩu không khớp')
    .required('Xác nhận mật khẩu là bắt buộc'),
});

const changePasswordSchema = yup.object().shape({
  oldPassword: yup.string().required('Mật khẩu là bắt buộc'),
  newPassword: yup
    .string()
    .min(7, 'Mật khẩu phải có nhiều hơn 6 ký tự')
    .required('Mật khẩu là bắt buộc'),
  confirmPassword: yup
    .string()
    .oneOf([yup.ref('newPassword')], 'Mật khẩu không khớp')
    .required('Xác nhận mật khẩu là bắt buộc'),
});

export { LoginSchema, emailSchema, passwordSchema, changePasswordSchema };
